export const ROUTES = {
	ROOT: '/',
	HOME: '/home',
	PROFILE: '/profile',
	EDIT_PROFILE: '/edit-profile',
	MARKET_PERFORMANCE: '/market-performance',
	ACCOUNT: '/account',
	LEADERBOARD: '/leaderboard',
	ADMIN: '/admin',
	ADMIN_CAMPAIGNS: '/admin/campaigns',
	ADMIN_CAMPAIGN_NEW: '/admin/campaigns/new',
	ADMIN_CAMPAIGN_EDIT: '/admin/campaigns/:id',
	EVENTS: '/events',
	EVENT_DETAILS: '/event-details',
	PROBABILITY_EVENT: '/probability-events',
	MARKETS: '/markets',
	LOBBY_DETAILS: '/lobby-details',
	BINGO: '/bingo',
	COURSES: '/courses',
	CREATE_LOBBY: '/create-lobby',
	EVENT_MANAGEMENT: '/event-management',
	CREATE_EVENT: '/create-event',
	EXTERNAL_LEADERBOARD: '/external-leaderboard',
	HOW_TO_PLAY: '/how-to-play',
	REFER: '/refer',
	AUTH: '/auth',
	H2H: '/head-to-head',
	SPONSOR: '/sponsor',
	SPONSOR_SLUG: '/sponsor/:slug',
	PROFILE_SETUP: '/profile-setup',
	PARENT_EMAIL_VERIFICATION: '/parent-email-verification',
	PARENTAL_CONSENT: '/parental-consent',
	NOT_FOUND: '/not-found',
};

export const AUTH_SCREENS = {
	WELCOME: 'welcome',
	SIGNUP: 'signup',
	BIRTHDATE: 'birthdate',
	UNDERAGE: 'underage',
} as const;

const OLD_ROUTES = {
	HOME: '/Home',
	PROFILE: '/Profile',
	EDIT_PROFILE: '/EditProfile',
	MARKET_PERFORMANCE: '/MarketPerformance',
	ACCOUNT: '/Account',
	LEADERBOARD: '/Leaderboard',
	ADMIN: '/Admin',
	EVENTS: '/Events',
	EVENT_DETAILS: '/EventDetails',
	MARKETS: '/Markets',
	LOBBY_DETAILS: '/LobbyDetails',
	CREATE_LOBBY: '/CreateLobby',
	EVENT_MANAGEMENT: '/EventManagement',
	CREATE_EVENT: '/CreateEvent',
	EXTERNAL_LEADERBOARD: '/ExternalLeaderboard',
	HOW_TO_PLAY: '/HowToPlay',
	REFER: '/Refer',
	AUTH: '/Auth',
};

export const REDIRECTS = {
	[OLD_ROUTES.HOME]: ROUTES.HOME,
	[OLD_ROUTES.PROFILE]: ROUTES.PROFILE,
	[OLD_ROUTES.EDIT_PROFILE]: ROUTES.EDIT_PROFILE,
	[OLD_ROUTES.MARKET_PERFORMANCE]: ROUTES.MARKET_PERFORMANCE,
	[OLD_ROUTES.ACCOUNT]: ROUTES.ACCOUNT,
	[OLD_ROUTES.LEADERBOARD]: ROUTES.LEADERBOARD,
	[OLD_ROUTES.ADMIN]: ROUTES.ADMIN,
	[OLD_ROUTES.EVENTS]: ROUTES.EVENTS,
	[OLD_ROUTES.EVENT_DETAILS]: ROUTES.EVENT_DETAILS,
	[OLD_ROUTES.MARKETS]: ROUTES.MARKETS,
	[OLD_ROUTES.LOBBY_DETAILS]: ROUTES.LOBBY_DETAILS,
	[OLD_ROUTES.CREATE_LOBBY]: ROUTES.CREATE_LOBBY,
	[OLD_ROUTES.EVENT_MANAGEMENT]: ROUTES.EVENT_MANAGEMENT,
	[OLD_ROUTES.CREATE_EVENT]: ROUTES.CREATE_EVENT,
	[OLD_ROUTES.EXTERNAL_LEADERBOARD]: ROUTES.EXTERNAL_LEADERBOARD,
	[OLD_ROUTES.HOW_TO_PLAY]: ROUTES.HOW_TO_PLAY,
	[OLD_ROUTES.REFER]: ROUTES.REFER,
	[OLD_ROUTES.AUTH]: ROUTES.AUTH,
};

// Auth-only screens: logged-in users are bounced away (e.g. /auth → home).
export const UNAUTHENTICATED_ROUTES = [ROUTES.AUTH];

// Parent approve/decline/revoke landing — must stay reachable even when the
// browser already has a student/admin session (email deep links).
export const PUBLIC_ALWAYS_ACCESSIBLE_ROUTES = [ROUTES.PARENTAL_CONSENT];

export const PENDING_CONSENT_ROUTES = [ROUTES.PARENT_EMAIL_VERIFICATION];

export const ADMIN_ROUTES = [
	ROUTES.ADMIN,
	ROUTES.MARKETS,
	ROUTES.CREATE_LOBBY,
	ROUTES.EVENT_MANAGEMENT,
	ROUTES.CREATE_EVENT,
];

export const REGISTERED_USER_ROUTES = [
	ROUTES.EDIT_PROFILE,
	ROUTES.ACCOUNT,
	ROUTES.REFER,
	ROUTES.MARKET_PERFORMANCE,
	ROUTES.PROFILE_SETUP,
];
